import { checkAuthenticationToken, login, isUnitTestActive } from '../lib/auth';
import { useXProps } from '../hooks/useXProps';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const withAuth = (
  Component: (props: Record<string, unknown>) => JSX.Element,
) => {
  const ComponentWithAuth = (props: Record<string, unknown>) => {
    const [authenticated, setAuthenticated] = useState<boolean | null>(null);
    const { tenant, initialRoute } = useXProps();
    const navigate = useNavigate();

    const checkAuth = useCallback(async () => {
      const token = await checkAuthenticationToken(tenant);
      if (token && initialRoute) {
        navigate(initialRoute);
      }
      setAuthenticated(!!token);
    }, [setAuthenticated, tenant]);

    useEffect(() => {
      if (tenant) {
        if (isUnitTestActive(tenant)) {
          setAuthenticated(true);
        } else {
          checkAuth();
        }
      }
    }, [tenant]);

    if (authenticated === null) {
      return null;
    } else if (!authenticated) {
      login(tenant);
      return null;
    } else {
      return <Component {...{ ...props, tenant }} />;
    }
  };
  return ComponentWithAuth;
};

export default withAuth;
